module.exports = __webpack_public_path__ + "static/media/Liabilities.a75da0d3.svg";